var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"transition-slide-right"}},[(_vm.showSideStockView)?_c('SideStockInfo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }